<button
  class="btn btn-light border-none"
  [ngClass]="{ 'btn-sm': compactView }"
  [disabled]="isDisabled || inputControl.value === min"
  (click)="onDecrease($event)"
  (touchstart)="startContinuesChange($event, ContiniouesChangeType.DECREASE)"
  (touchend)="clearContinuesValueChange()"
  data-e2e="button-decrease"
  i18n="Ataraxia|Clickable amount input@@minus"
>
  -
</button>
<div class="value d-inline-flex justify-content-center">
  @if (forceInputShow) {
  <ng-container *ngTemplateOutlet="inputTmpl"></ng-container>
  } @else {
  <div class="container-content w-100" #ref><ng-content></ng-content></div>
  @if (!ref.innerHTML.trim()) {
  <ng-container *ngTemplateOutlet="inputTmpl"></ng-container>
  } }
</div>
<button
  class="btn btn-light border-none"
  [ngClass]="{ 'btn-sm': compactView }"
  [disabled]="isDisabled || inputControl.value >= max"
  (click)="onIncrease($event)"
  (touchstart)="startContinuesChange($event, ContiniouesChangeType.INCREASE)"
  (touchend)="clearContinuesValueChange()"
  data-e2e="button-increase"
  i18n="Ataraxia|Clickable amount input@@pluse"
>
  +
</button>

<ng-template #inputTmpl>
  <input
    #input
    type="number"
    atxNumberInput
    inputmode="numeric"
    placeholder="0"
    [formControl]="inputControl"
    (blur)="onInputBlur()"
    (focus)="input.select()"
    atxMax
    [max]="max"
    [min]="min"
    data-e2e="value"
  />
</ng-template>
